import React, { forwardRef, useState } from 'react';
import Button from '../button/button';
import './dropdown.scss';

export interface DropdownProps {
    isOpen: boolean;
    hasSubmit: boolean;
    options?: string[];
    onSubmit?: (options: string[]) => void;
    children?: JSX.Element | JSX.Element[];
}

const Dropdown = ({ isOpen = false, hasSubmit, options, children = [], onSubmit }: DropdownProps, ref: React.Ref<HTMLDivElement>) => {

    const [selectedOptions, selectOption] = useState<string[]>([]);

    return (
        <div ref={ref} className={"dropdown " + (isOpen ? "" : "hidden")} data-testid="dropdown">
            <div className="options-container">
                {(Array.isArray(children) ? children.length > 0 : children) ?
                    <>
                        {children}
                    </>
                    :
                    <>
                        {options?.map((option: string) => (
                            <div key={option}>
                                <input type="checkbox" value={option} onChange={() => selectOption([...selectedOptions, option])} />
                                <span>{option}</span>
                            </div>
                        ))}
                    </>
                }
            </div>
            {(hasSubmit && onSubmit) &&
                <Button variant="button" onClick={() => onSubmit(selectedOptions)}>Submit</Button>
            }
        </div >
    );
};

export default forwardRef(Dropdown);